<template>
  <div id="reportOuter">
    <div>
      <h5>Report View - Unit Servicing Report</h5>
      <div>
        <img
          id="menuGraphic"
          align="right"
          src="../assets/PDFIconSmall.png"
          v-on:click="createPDF()"
        />
        <img
          id="menuGraphic"
          align="right"
          src="../assets/excelSmall.png"
          v-on:click="
            exportTableToExcel(
              'ServicingReport',
              'Servicing_Report_Export_' + new Date().toLocaleDateString()
            )
          "
        />
        <br />
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="ServicingReport"
      ></b-pagination>
    </div>
    <div id="Report">
      <b-table
        stacked="md"
        id="ServicingReport"
        striped
        hover
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-desc.sync="sortDesc"
        :sort-by.sync="sortBy"
        small
        label-sort-asc=""
        label-sort-desc=""
        label-sort-clear=""
      ></b-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      fields: [
        {
          key: "UnitID",
          label: "Unit ID",
          sortable: true,
        },
        {
          key: "Location",
          sortable: true,
        },
        {
          key: "WardDept",
          label: "Ward/Dept",
          sortable: true,
        },
        {
          key: "UnitType",
          label: "Type",
          sortable: true,
        },
        {
          key: "LastService",
          label: "Last Service Date",
          sortable: true,
        },
        {
          key: "NextServiceBooked",
          label: "Next Service Booked",
          sortable: true,
        },
        {
          key: "NextService",
          label: "Next Service Date",
          sortable: true,
        },
      ],
      items: [
        {
          UnitID: "MIC7654323",
          Location: "Queen Elizabeth",
          WardDept: "ICU",
          UnitType: "Michael",
          LastService: "21/02/2018",
          NextServiceBooked: "True",
          NextService: "21/02/2021",
        },
        {
          UnitID: "GAB7654987",
          Location: "Glasgow Royal",
          WardDept: "HDU",
          UnitType: "Gabriel",
          LastService: "10/10/2020",
          NextServiceBooked: "False",
          NextService: "",
        },
        {
          UnitID: "MIC7698663",
          Location: "Queen Elizabeth",
          WardDept: "Ward 4",
          UnitType: "Michael",
          LastService: "",
          NextServiceBooked: "True",
          NextService: "04/12/2020",
        },
        {
          UnitID: "MIC7658752",
          Location: "Queen Elizabeth",
          WardDept: "A&E",
          UnitType: "Michael",
          LastService: "21/02/2018",
          NextServiceBooked: "True",
          NextService: "21/02/2021",
        },
        {
          UnitID: "GAB2334323",
          Location: "Stobhill",
          WardDept: "Ward 1b",
          UnitType: "Gabriel",
          LastService: "15/09/2019",
          NextServiceBooked: "True",
          NextService: "21/05/2021",
        },
        {
          UnitID: "MIC7687723",
          Location: "Queen Elizabeth",
          WardDept: "Ward 12",
          UnitType: "Michael",
          LastService: "",
          NextServiceBooked: "True",
          NextService: "01/11/2020",
        },
        {
          UnitID: "MIC7009323",
          Location: "Queen Elizabeth",
          WardDept: "Ward 12",
          UnitType: "Michael",
          LastService: "19/10/2020",
          NextServiceBooked: "False",
          NextService: "",
        },
        {
          UnitID: "GAB9624323",
          Location: "Inverclyde",
          WardDept: "Ward 3",
          UnitType: "Gabriel",
          LastService: "29/09/2020",
          NextServiceBooked: "True",
          NextService: "29/09/2021",
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },

  methods: {
    exportTableToExcel: function(tableID, filename = "") {
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById(tableID);
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
    },

    createPDF: function() {
      var sTable = document.getElementById("Report").innerHTML;

      var style = "<style>";
      style = style + "table {width: 100%;font: 12px Verdana;}";
      style =
        style +
        "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
      style = style + "padding: 2px 3px;text-align: center;}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      var win = window.open("", "", "height=700,width=700");

      win.document.write("<html><head>");
      win.document.write("<title>Servicing Report</title>"); // <title> FOR PDF HEADER.
      win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      win.document.write("</head>");
      win.document.write("<body>");
      win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      win.document.write("</body></html>");

      win.print(); // PRINT THE CONTENTS.

      win.document.close(); // CLOSE THE CURRENT WINDOW.

      win.close();
    },
  },
};
</script>

<style scoped></style>
